import PageTitle from "components/PageTitle";
import React, { useEffect, useState } from "react";
import { Button, Card, Col, Form, Row, Toast } from "react-bootstrap";
import {
  getAutoavaliacaoCampos,
  syncAutoavaliacaoCampos,
} from "./FormularioApi";
import PerguntasApagadasModal from "./PerguntasApagadasModal";

interface IOpcao {
  valor: number;
  label: string;
}

interface ICampo {
  id?: number;
  titulo: string;
  peso: number;
  opcoes: IOpcao[];
}

export default function AutoavaliacaoFormulario() {
  const [campos, setCampos] = useState<ICampo[]>([]);

  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastType, setToastType] = useState("");

  const [salvarDisplay, setSalvarDisplay] = useState(false);
  const [recuperar, setRecuperar] = useState(false);

  useEffect(() => {
    carregar();
  }, []);

  async function carregar() {
    const response = await getAutoavaliacaoCampos();
    setCampos(response.data);
  }

  function criarCampo() {
    setCampos((old) => [
      ...old,
      {
        titulo: "",
        peso: 1,
        opcoes: [
          { valor: 0, label: "" },
          { valor: 1, label: "" },
          { valor: 2, label: "" },
          { valor: 3, label: "" },
          { valor: 4, label: "" },
        ],
      },
    ]);
  }

  function atualizarCampo(index: number, alteracoes: Partial<ICampo>) {
    setCampos((old) =>
      old.map((campo, i) =>
        i === index
          ? {
              ...campo,
              ...alteracoes,
            }
          : campo,
      ),
    );
  }

  function atualizarOpcao(
    campoIndex: number,
    opcaoIndex: number,
    label: string,
  ) {
    setCampos((old) =>
      old.map((campo, i) => {
        if (i !== campoIndex) return campo;

        const opcoes = [...campo.opcoes];
        opcoes[opcaoIndex] = {
          ...opcoes[opcaoIndex],
          label,
        };

        return {
          ...campo,
          opcoes,
        };
      }),
    );
  }

  function removerCampo(index: number) {
    setCampos((old) => old.filter((_, i) => i !== index));
  }

  async function salvar() {
    await syncAutoavaliacaoCampos(campos);
    await carregar();
  }

  return (
    <>
      <PageTitle
        breadCrumbItems={[
          {
            label: "Autoavaliação",
            path: "/#",
          },
          {
            label: "Formulário",
            path: "/autoavaliacao-superiores/formulario",
            active: true,
          },
        ]}
        title="Gerenciamento de formulário de autoavaliação"
      />

      <div
        style={{
          position: "fixed",
          top: 20,
          right: 20,
          zIndex: 1050,
        }}
      >
        <Toast
          show={showToast}
          onClose={() => setShowToast(false)}
          delay={2500}
          autohide
          bg={toastType === "success" ? "success" : "danger"}
        >
          <Toast.Body className="text-white">{toastMessage}</Toast.Body>
        </Toast>
      </div>

      <div
        className="mb-3"
        style={{
          display: "flex",
          justifyContent: "flex-end",
          gap: "1%",
        }}
      >
        <Button
          variant="outline-primary"
          onClick={() => {
            setRecuperar(true);
          }}
        >
          <i className="mdi mdi-redo me-1" />
          Recuperar
        </Button>
        <Button onClick={criarCampo}>
          <i className="mdi mdi-plus-circle me-1" />
          Novo
        </Button>
      </div>

      {campos.map((campo, index) => (
        <Card className="mb-3" key={campo.id ?? index}>
          <Card.Body>
            <Row>
                <Col md={8}>
                  <Form.Group>
                    <Form.Label>Pergunta</Form.Label>
                    <Form.Control
                      value={campo.titulo}
                      onChange={(e) =>
                        atualizarCampo(index, {
                          titulo: e.target.value,
                        })
                      }
                    />
                  </Form.Group>
                </Col>

                <Col md={2}>
                  <Form.Group>
                    <Form.Label>Peso</Form.Label>
                    <Form.Control
                      type="number"
                      min={1}
                      value={campo.peso}
                      onChange={(e) =>
                        atualizarCampo(index, {
                          peso: Number(e.target.value) || 1,
                        })
                      }
                    />
                  </Form.Group>
                </Col>

                <Col xs="auto" className="ms-auto mt-3">
                  <Button
                    variant="danger"
                    className="w-12"
                    onClick={() => removerCampo(index)}
                  >
                    <i className="mdi mdi-delete" />
                  </Button>
                </Col>

              {campo.opcoes.map((opcao, opcaoIndex) => (
                <Col md={6} className="mt-3" key={opcao.valor}>
                  <Form.Group>
                    <Form.Label>Título da opção {opcao.valor + 1}</Form.Label>

                    <Form.Control
                      value={opcao.label}
                      placeholder={
                        opcao.valor == 0
                          ? "Discordo completamente"
                          : opcao.valor == 1
                          ? "Discordo parcialmente"
                          : opcao.valor == 2
                          ? "Indiferente"
                          : opcao.valor == 3
                          ? "Concordo parcialmente"
                          : "Concordo Completamente"
                      }
                      onChange={(e) =>
                        atualizarOpcao(index, opcaoIndex, e.target.value)
                      }
                    />
                  </Form.Group>
                </Col>
              ))}
            </Row>
          </Card.Body>
        </Card>
      ))}

      <div
        style={{
          position: "fixed",
          bottom: 20,
          zIndex: 9999,
        }}
      >
        <Button
          variant="success"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: salvarDisplay ? "5%" : "50%",
            opacity: salvarDisplay ? 1 : 0.9,
            transition: "all .3s ease",
          }}
          onMouseOver={() => setSalvarDisplay(true)}
          onMouseOut={() => setSalvarDisplay(false)}
          onClick={async () => {
            try {
              await salvar();

              setToastType("success");
              setToastMessage("Salvo com sucesso!");
              setShowToast(true);
            } catch {
              setToastType("danger");
              setToastMessage("Erro ao salvar formulário.");
              setShowToast(true);
            }
          }}
        >
          <i className="mdi mdi-content-save" />

          <span
            style={{
              overflow: "hidden",
              whiteSpace: "nowrap",
              marginLeft: salvarDisplay ? ".25rem" : "0",
              maxWidth: salvarDisplay ? "60px" : "0",
              opacity: salvarDisplay ? 1 : 0,
              transition: "all .3s ease",
            }}
          >
            Salvar
          </span>
        </Button>
      </div>
      <PerguntasApagadasModal
        show={recuperar}
        onHide={() => {
          setRecuperar(false);
        }}
      />
    </>
  );
}
